module.exports = __webpack_public_path__ + "static/media/CSharpBoiler.c5d27f6f.png";